import React, { useMemo } from 'react';
import { ApplicationSummary } from 'screens/Applications&WorkOrders/Applications/Hooks/useApplication';
import RowItem from '../Components/RowItem';
import { OperationSummary } from '../Components/types';

interface UseListViewColumnsProps {
  selectedId: string | null;
  onSelectId: (id: string | null) => void;
  allTags?: Array<{ id: string; name: string; color: string }>;
  searchTerm?: string;
}

const useListViewColumns = ({
  selectedId,
  onSelectId,
  allTags,
  searchTerm = ''
}: UseListViewColumnsProps) => {
  const rowSelection = useMemo(
    () => ({
      type: 'radio' as const,
      selectedRowKeys: selectedId ? [selectedId] : [],
      onChange: (selectedRowKeys: React.Key[]) => {
        const id = selectedRowKeys[0] as string;
        onSelectId(id || null);
      },
      columnWidth: 0,
      hideSelectAll: true,
      preserveSelectedRowKeys: false,
      renderCell: () => null,
      getCheckboxProps: (record: ApplicationSummary) => ({
        name: `item-${record.id}`,
        style: { display: 'none' }
      })
    }),
    [selectedId, onSelectId]
  );

  const columns = useMemo(
    () => [
      {
        dataIndex: 'name',
        key: 'name',
        render: (_: any, record: OperationSummary) => (
          <RowItem
            operation={record}
            isSelected={selectedId === record.id}
            allTags={allTags}
            searchTerm={searchTerm}
          />
        )
      }
    ],
    [selectedId, allTags, searchTerm]
  );

  return {
    rowSelection,
    columns
  };
};

export default useListViewColumns;
